import { writable } from 'svelte/store';

export const menuOpen = writable(false);
export const pageScrolled = writable(false);
export const scrollDistance = writable(0);
